<template>
  <a-spin :spinning="loading">
    <a-radio-group v-if="list.length" :value="field.value" button-style="solid" @change="onChange">
      <a-radio-button v-for="item in list" :key="item.value" :value="item.value">{{ item.label }}</a-radio-button>
    </a-radio-group>
    <span v-else class="gray9 fs12">
      {{ config.placeholder || '暂无数据' }}
    </span>
  </a-spin>
</template>
<script>
import { defineComponent, toRef, ref, computed } from 'vue';
import { props } from './helper';
import useRemote from './useRemote';

export default defineComponent({
  props,
  setup(props) {
    const config = toRef(props, 'config');
    const { loading } = useRemote(props, res => {
      const { attrs = {} } = config.value.remoteApi;
      const remoteList = (res.data.List || res.data.list || []).map(i => {
        return { value: i[attrs.valueField], label: i[attrs.labelField] };
      });
      list.value = config.value.list ? [...config.value.list, ...remoteList] : remoteList;
    });

    const onChange = e => {
      props.handleChange(e.target.value);
    };

    const list = computed(() => config.value.list);

    return {
      list,
      loading,
      onChange,
    };
  },
});
</script>
<style lang="less" scoped></style>
